import { State } from '../../../../state/store';

export const selectUnauthorizedUrl = (state: State): string | undefined =>
    state.error.unauthorizedUrl;

export const selectUnauthorizedActionAttempted = (
    state: State
): boolean | undefined => state.error.unauthorizedActionAttempted;
